import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { UhxShopifyMap } from 'content/products/uhx';
import { CnoPlusShopifyMap } from 'content/products/addons/cnoPlus';
import { CnoProShopifyMap } from 'content/products/addons/cnoPro';
import { CardioAdaptibilityShopifyMap } from 'content/products/addons/cardioAdaptibility';
// import { RespiratoryShopifyMap } from 'content/products/addons/respiratory';

export interface ShopPowerPlug {
  title: string;
  description: string;
  imgSrc: string;
  year1: { price: number; variantId: string };
  year2?: { price: number; variantId: string; save: number };
  tag?: string;
}

export function getShopPowerPlugs(
  store: ShopifyStore,
  isCnOPlus: boolean,
): ShopPowerPlug[] {
  const uhx = UhxShopifyMap[store];
  const cnoPlus = CnoPlusShopifyMap[store];
  const cnoPro = CnoProShopifyMap[store];
  const cardio = CardioAdaptibilityShopifyMap[store];
  // const respiratory = RespiratoryShopifyMap[store];

  const showCnoPlus = isCnOPlus;

  return [
    {
      title: 'UltrahumanX Membership',
      description:
        'Coverage for everything Ultrahuman. Damage, loss and theft protection, with priority support.',
      imgSrc: 'web_v2/shop/powerplugs/pp-uhx-1.png',
      year1: {
        price: uhx?.Year1?.price ?? 0,
        variantId: uhx?.Year1?.variantId ?? '',
      },
      ...(uhx?.Year2 && {
        year2: {
          price: uhx.Year2.price,
          variantId: uhx.Year2.variantId,
          save: Math.round(
            ((uhx.Year1.price * 2 - uhx.Year2.price) / (uhx.Year1.price * 2)) *
              100,
          ),
        },
      }),
    },
    ...(showCnoPlus
      ? [
          {
            title: 'Cycle & Ovulation Plus PowerPlug',
            description:
              "The world's most accurate cycle and ovulation tracker, trained on 260,000+ cycles. A software add-on for your ring.",
            imgSrc: 'web_v2/shop/powerplugs/cycle-ovulation-plus-fin.png?v=2',
            year1: {
              price: cnoPlus?.Year1?.price ?? 0,
              variantId: cnoPlus?.Year1?.variantId ?? '',
            },
            ...(cnoPlus?.Year2 && {
              year2: {
                price: cnoPlus.Year2.price,
                variantId: cnoPlus.Year2.variantId,
                save: cnoPlus.Year2.save,
              },
            }),
          },
        ]
      : [
          {
            title: 'Cycle & Ovulation Pro PowerPlug',
            description:
              "The world's most accurate cycle and ovulation tracker. Trained on 260,000+ cycles, with 90%+ ovulation accuracy.",
            imgSrc: 'web_v2/shop/powerplugs/cycle-ovulation-pro-fin.png?v=2',
            year1: {
              price: cnoPro?.Year1?.price ?? 0,
              variantId: cnoPro?.Year1?.variantId ?? '',
            },
            ...(cnoPro?.Year2 && {
              year2: {
                price: cnoPro.Year2.price,
                variantId: cnoPro.Year2.variantId,
                save: cnoPro.Year2.save,
              },
            }),
          },
        ]),
    {
      title: 'Cardio Adaptability PowerPlug',
      description:
        'Nightly cardio analysis — how your heart responds to activity, stress and rest. A software add-on for your ring.',
      imgSrc: 'web_v2/shop/powerplugs/cardio-fin.png?v=2',
      year1: {
        price: cardio?.Year1?.price ?? 0,
        variantId: cardio?.Year1?.variantId ?? '',
      },
      ...(cardio?.Year2 && {
        year2: {
          price: cardio.Year2.price,
          variantId: cardio.Year2.variantId,
          save: cardio.Year2.save,
        },
      }),
    },
    // {
    //   title: 'Respiratory',
    //   description:
    //     "See what's really happening while you sleep. Track snoring and breathing disruptions, and understand how they affect your heart rate, HRV, and recovery.",
    //   imgSrc: 'web_v2/shop/powerplugs/respiratory.png',
    //   year1: {
    //     price: respiratory?.Year1?.price ?? 0,
    //     variantId: respiratory?.Year1?.variantId ?? '',
    //   },
    // },
  ];
}
